import { render } from "./my_certificate.vue?vue&type=template&id=696eb337&scoped=true"
import script from "./my_certificate.vue?vue&type=script&lang=js"
export * from "./my_certificate.vue?vue&type=script&lang=js"

import "./my_certificate.vue?vue&type=style&index=0&id=696eb337&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696eb337"]])

export default __exports__